<template>
    <div class="HeaderBusinessDetail">
        <div class="HeaderBusinessDetail__Header">
            <Header :title="$t('business.business')" />
        </div>
        <div class="HeaderBusinessDetail__goBack" @click="goBack">
            <Icon name="keyboard-arrow-left" style="color: red" />
            <GoBack :cancel="$t('advertisement.go-back')" />
        </div>
    </div>
</template>

<script>
  import { Card, Header } from '@/components';
  import { Header as GoBack } from 'daas-components';
  import Icon from '@/components/Icon';

  export default {
    name: 'HeaderBusinessDetail',
    components: {
      Card,
      Icon,
      Header,
      GoBack,
    },
    methods: {
      goBack() {
        this.$router.push('/dashboard');
      },
    },
  };
</script>

<style lang="scss">
    .HeaderBusinessDetail {
        &__goBack {
            display: flex;
            align-items: center;
            cursor: pointer;
            text-transform: uppercase;
            width: 100%;
            justify-content: center;
        }
        &__Header {
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }
</style>
